import React from "react";
import { Helmet } from "react-helmet";
import Layout from "../../components/App/Layout";
import ChartScreen from "../../RaymonComponents/chart/ChartScreen";
import PageBanner from "../../RaymonComponents/Commn/PageBanner";
import Footer from "../../RaymonComponents/Footer2";
import NavbarTwo from "../../RaymonComponents/Navbar";
import { Router } from "@reach/router";
import FeaturedServices from "../../RaymonComponents/Features/Features";
const Features = () => {
  return (
    <>
      <Helmet>
        {/* <link
          rel="stylesheet"
          href="https://pro.fontawesome.com/releases/v5.10.0/css/all.css"
          integrity="sha384-AYmEC3Yw5cVb3ZcuHtOA93w35dYTsvhLPVnYs9eStHfGJvOvKxVfELGroGkvsg+p"
          crossorigin="anonymous"
        /> */}
        <link rel="stylesheet" href="../../assets/fontawesome/css/all.css" />
      </Helmet>
      <Layout>
        <NavbarTwo />
        <PageBanner
          pageTitle="امکانات"
          homePageText="امکانات"
          homePageUrl="/"
          activePageText="خانه"
        />
        <FeaturedServices />
        <Footer />
      </Layout>
    </>
  );
};
export default Features;
